export default getText => key =>
  ({
    btnLabel: getText('Help & Support', 'Auth_Help'),
    start: getText('Getting Started', 'Auth_Help'),
    faq: getText('FAQ', 'Auth_Help'),
    support: getText('Support', 'Auth_Help'),
    language: getText('Language', 'Auth_Help'),
  }[key])
